import { INavLink, IRoutes, ISideBar, IRouteModule, RoutesModules } from './../../types'
import { UserTypes } from 'src/modules/Auth/store/types';
import { validateAuthentication } from 'src/modules/Auth/helpers/validateAuthentication';

const isAuthorized = (userType: UserTypes, navbar: string, routes: IRoutes[]) => {
  const linkRoute = routes.find(route => {
    const path = route.paths.find(componentPath => componentPath === navbar);
    return !!path;
  });
  if (linkRoute) {
    const { authorized } = validateAuthentication(userType, linkRoute.policies);
    if (authorized) {
      return true;
    }
  }
  return false
}

export interface ISideBarLinks {
  settings: INavLink[],
  body: INavLink[]
}

export const linkSidebars = (userType: UserTypes, modules: IRouteModule[], moduleName: RoutesModules): ISideBar[] => {
  const selectedModule = modules.find((module) => module.name === moduleName) as IRouteModule;
  return linkModuleSidebars(selectedModule, userType)
}
export const linkModuleSidebars = (selectedModule: IRouteModule, userType: UserTypes) => {
  const sidebars = selectedModule.sidebar || [];
  return sidebars.reduce((final, sidebar) => {
    if (isAuthorized(userType, sidebar.route, selectedModule.routes)) {
      return [...final, { ...sidebar, modulePath: selectedModule.navbar }]
    }
    return final;
  }, [] as ISideBar[])
}



// WEBPACK FOOTER //
// ./src/modules/Routing/hooks/sideBars/linkSidebars.ts